/*eslint-disable*/
import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import Drawer from '@mui/material/Drawer';
import Hidden from '@mui/material/Hidden';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Icon from '@mui/material/Icon';
// core components
import AdminNavbarLinks from '@/components/Navbars/AdminNavbarLinks';
import RTLNavbarLinks from '@/components/Navbars/RTLNavbarLinks';
import logoimg from '@/assets/img/tailfin-logo.png';

import styles from '@/assets/jss/material-dashboard-react/components/sidebarStyle';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { checkOrganizationFeatures } from '@/utility';

const useStyles = makeStyles(styles);

export default function Sidebar(props) {
  const classes = useStyles();
  const { color, logo, image, logoText, routes } = props;

  const links = (
    <List className={classes.list}>
      {routes.map((prop, key) => (
        <SidebarLink
          key={key}
          prop={{ ...prop, key }}
          color={color}
          classes={classes}
          rtlActive={props.rtlActive}
        />
      ))}
    </List>
  );

  var brand = (
    <div className={classes.logo}>
      <div
        className={classes.logoImage}
        style={{
          padding: '10px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <img src={logoimg} alt='logo' />
      </div>
      {/* logoText */}
    </div>
  );
  return (
    <div>
      <Hidden mdUp implementation='css'>
        <Drawer
          variant='temporary'
          anchor={props.rtlActive ? 'right' : 'left'}
          open={props.open}
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive,
            }),
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}>
          {brand}
          <div className={classes.sidebarWrapper}>
            {props.rtlActive ? <RTLNavbarLinks /> : <AdminNavbarLinks />}
            {links}
          </div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: 'url(' + image + ')' }}
            />
          ) : null}
        </Drawer>
      </Hidden>
      <Hidden mdDown implementation='css'>
        <Drawer
          anchor={props.rtlActive ? 'right' : 'left'}
          variant='permanent'
          open
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive,
            }),
          }}>
          {brand}
          <div className={classes.sidebarWrapper}>{links}</div>
          {image !== undefined ? <div className={classes.background} /> : null}
        </Drawer>
      </Hidden>
    </div>
  );
}

Sidebar.propTypes = {
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  bgColor: PropTypes.oneOf(['purple', 'blue', 'green', 'orange', 'red']),
  logo: PropTypes.string,
  image: PropTypes.string,
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool,
};

function SidebarLink({ prop, color, classes, rtlActive }) {
  const { t } = useTranslation();
  const activeRoute = (routeName) =>
    window.location.href.indexOf(routeName) > -1;

  const invert = prop.featureFlagOption?.invert ?? false;

  if (prop.featureFlag) {
    const featureFlagEnabled = useFeatureFlagEnabled(prop.featureFlag);
    if (invert ? featureFlagEnabled : !featureFlagEnabled) {
      return null;
    }
  }
  if (
    prop.organizationFeature &&
    !checkOrganizationFeatures(prop.organizationFeature)
  ) {
    return null;
  }

  if (prop.invisible) return null;

  const activePro =
    prop.path === '/upgrade-to-pro' ? classes.activePro + ' ' : ' ';
  const listItemClasses = classNames({
    [' ' + classes[color]]:
      prop.path === '/upgrade-to-pro' || activeRoute(prop.layout + prop.path),
  });
  const whiteFontClasses = classNames({
    [' ' + classes.whiteFont]: activeRoute(prop.layout + prop.path),
  });

  return (
    <NavLink
      to={prop.layout + prop.path}
      className={activePro + classes.item}
      key={prop.key}>
      <ListItem button className={classes.itemLink + listItemClasses}>
        {typeof prop.icon === 'string' ? (
          <Icon
            className={classNames(classes.itemIcon, whiteFontClasses, {
              [classes.itemIconRTL]: rtlActive,
            })}>
            {prop.icon}
          </Icon>
        ) : (
          <prop.icon
            className={classNames(classes.itemIcon, whiteFontClasses, {
              [classes.itemIconRTL]: rtlActive,
            })}
          />
        )}
        <ListItemText
          primary={
            rtlActive
              ? prop.rtlName
              : prop.translationKey
              ? t(prop.translationKey)
              : prop.name
          }
          className={classNames(classes.itemText, whiteFontClasses, {
            [classes.itemTextRTL]: rtlActive,
          })}
          disableTypography={true}
        />
      </ListItem>
    </NavLink>
  );
}
